import { Form, Input, Button, notification } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { postSignIn } from "services/SauceService";
import { useDispatch } from "react-redux";
import { getBusinessInfo, getBusinessess } from "redux-context/business";
import { getLoggedUserInfo } from "redux-context/user";
import { Link } from "react-router-dom";
import { getDomainMetadata } from "redux-context/domain";
import { ReactComponent as Logo } from "assets/images/logo.svg";
import "./Login.scss";

const Login: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [api, contextHolder] = notification.useNotification();
  const dispatch = useDispatch<any>();

  const [form] = Form.useForm();

  const onFinish = async () => {
    setLoading(true);
    const values = form.getFieldsValue(true);
    try {
      const response: any = await postSignIn(values);
      if (response && response.accessToken) {
        localStorage.setItem("token", response.accessToken);
        if (response.businessId)
          localStorage.setItem("businessId", response.businessId);
        dispatch(getBusinessess());
        dispatch(getBusinessInfo());
        dispatch(getDomainMetadata());
        dispatch(getLoggedUserInfo());
        const returnURL = sessionStorage.getItem("returnURL");
        sessionStorage.removeItem("returnURL");
        if (returnURL && returnURL !== "/login") navigate(returnURL);
        else navigate("/");
      } else {
        setLoading(false);
        api.error({
          message: "Error",
          description: "User without business",
        });
      }
    } catch (error) {
      setLoading(false);
      api.error({
        message: "Error",
        description: "Invalid email or password",
      });
    }
  };

  return (
    <div className="login-page">
      {contextHolder}
      <div className="login-card">
        {/* optional logo */}
        <Logo className="login-logo" />
        <Form
          form={form}
          name="login"
          onFinish={onFinish}
          className="login-form"
        >
          <h2 className="login-title">Login</h2>
          <Form.Item
            name="email"
            rules={[{ required: true, message: "Please input your email!" }]}
          >
            <Input prefix={<UserOutlined />} placeholder="Email" />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: "Please input your password!" }]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder="Password" />
          </Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="login-button"
            loading={loading}
            block
          >
            Sign In
          </Button>
          <div className="login-footer">
            <Link className="login-forgot" to="/forgot-password">
              Forgot your password
            </Link>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default Login;
